import { NgModule } from '@angular/core';
import { GiantInnerScrollDirective } from './giant-inner-scroll/giant-inner-scroll.directive';
import { GiantMatSidenavTogglerDirective, GiantMatSidenavHelperDirective } from './giant-mat-sidenav/giant-mat-sidenav.directive';
import { GiantPerfectScrollbarDirective } from './giant-perfect-scrollbar/giant-perfect-scrollbar.directive';



@NgModule({
    declarations: [
      
        GiantInnerScrollDirective,
        GiantMatSidenavTogglerDirective,
        GiantPerfectScrollbarDirective,
        GiantMatSidenavHelperDirective
    ],
    imports     : [],
    exports     : [
     
        GiantInnerScrollDirective,
        GiantMatSidenavTogglerDirective,
        GiantPerfectScrollbarDirective,
        GiantMatSidenavHelperDirective
    ]
})
export class GiantDirectivesModule
{
}
